const handleInstafeedCard = () => {
  const wrapper = document.querySelector('.instafeed-new-layout-wrapper[data-feed-id="42712"]');
  const firstItem = wrapper?.querySelector('.instafeed-new-layout-item:first-child');
  const customCard = document.querySelector('.instagram-follow-card');

  if (!firstItem || !customCard) return;

  if (window.innerWidth > 1024) {
    if (!firstItem.classList.contains('js-custom-card-instafeed')) {
      firstItem.innerHTML = customCard.innerHTML;
      firstItem.classList.add('instagram-follow-card', 'js-custom-card-instafeed');
    }
  } else {
    firstItem.classList.remove('instagram-follow-card', 'js-custom-card-instafeed');
  }
};

const instafeedMutationCallback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      const wrapper = document.querySelector('.instafeed-new-layout-wrapper[data-feed-id="42712"]');
      const customCard = document.querySelector('.instagram-follow-card');

      if (wrapper && customCard) {
        handleInstafeedCard();
        observer.disconnect();
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  handleInstafeedCard();
  const wrapper = document.querySelector('.instafeed-new-layout-wrapper[data-feed-id="42712"]');
  const customCard = document.querySelector('.instagram-follow-card');

  if (!wrapper || !customCard) {
    const observer = new MutationObserver(instafeedMutationCallback);

    observer.observe(document.body, {
      childList: true,
    });
  }
});

window.addEventListener('resize', handleInstafeedCard);
